module.exports = __webpack_public_path__ + "img/list.ca858fc0.svg";